// src/auth/RequireAuth.js

import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const RequireAuth = () => {
  const token = sessionStorage.getItem("token");

  if (!token) {
    return <Navigate to="/admin-login" replace />;
  }

  try {
    const decoded = jwtDecode(token);

    const currentTime = Date.now() / 1000;

    // token expired
    if (decoded.exp < currentTime) {
      sessionStorage.removeItem("matrimonyAdmin");
      sessionStorage.removeItem("token");

      return <Navigate to="/admin-login" replace />;
    }

    // token valid
    return <Outlet />;
  } catch (error) {
    // // invalid token
    // sessionStorage.clear();
    sessionStorage.removeItem("matrimonyAdmin");
    sessionStorage.removeItem("token");

    return <Navigate to="/admin-login" replace />;
  }
};

export default RequireAuth;
